import { render, staticRenderFns } from "./FuhrparkDetail.vue?vue&type=template&id=085d0d2f"
import script from "./FuhrparkDetail.vue?vue&type=script&lang=js"
export * from "./FuhrparkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports